import { useReferralsInsightsActions, useReferralsInsightsStore } from 'stores/referralsInsightsStore';

import createInsightsDashboardContainer from '../shared/createInsightsDashboardContainer';

import ReferralsPage from './ReferralsPage';

const { Context, useDashboardContext, Container } = createInsightsDashboardContainer({
  preferenceKey: 'referralsProviderType',
  useSelectedGroupType: () => useReferralsInsightsStore((state) => state.selectedReceivingGroupType),
  useActions: () => {
    const { setSelectedReceivingGroupType: setSelectedGroupType, resetFilters } = useReferralsInsightsActions();
    return { setSelectedGroupType, resetFilters };
  },
  Page: ReferralsPage,
});

export const ReferralsInsightsContext = Context;
export const useReferralsInsightsContext = useDashboardContext;
export default Container;
